import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ActionPayload, BulkDataLakeFileUploadRequestInput, DataLakeFileUploadRequestInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPLOAD_FILE = gql`
    mutation executeDataLakeFileUpload ($input: BulkDataLakeFileUploadRequestInput!) {
        executeDataLakeFileUpload(input: $input) {
            message
            errors {
                code
                message
            }
            result
            data
        }
    }
`;

export const MutationUploadDataLakeFile = async (
    client: ApolloClient<NormalizedCacheObject>,
    fileInputs: DataLakeFileUploadRequestInput[]
    ): Promise<ActionPayload | undefined> => {
        const {data, errors } = await client.mutate<{executeDataLakeFileUpload: ActionPayload}>({
            variables: {
                input: {
                    dataLakeFileUploadRequests: fileInputs
                }
            },
            mutation: MUTATION_UPLOAD_FILE
        });
        if (errors && errors.length > 0) {
            errors.forEach(error => {
                // Log error details in the console
                console.error(error);
            });
            // Friendly error to active user
            throw new Error('An error has occurred trying to execute Data Lake file upload.');
        }
        if (data && data.executeDataLakeFileUpload) {
            return data.executeDataLakeFileUpload;
        }
    
        return undefined;
    };